import { DealerAccessAuthorizer, UserPrincipal } from '@gplibraries/utils';
import { useConfig } from '@gplibraries/react/hooks';
/**
 * Custom React hook to create a DealerAccessAuthorizer instance.
 * @param tokenClaims Access token claims used to make authorization decisions. Can be null if the token is not
 * available or invalid.
 * @returns DealerAccessAuthorizer instance
 */
export function useAuthorizer(tokenClaims) {
    // Get identity config (should contain groups and roles)
    const identityConfig = useConfig('identity');
    if (!identityConfig) {
        throw new Error("Configuration for 'identity' must be set to use the useAuthorizer hook.");
    }
    return tokenClaims
        ? new DealerAccessAuthorizer(UserPrincipal.fromToken(tokenClaims), identityConfig.groups, identityConfig.roles)
        : null;
}
